import { LoaderFunction } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api.ts";
import {PaginatedDiscountCodeLoaderData} from "@/routes/lecturer/routes/discountCode/main/types/paginatedDiscountCodeLoaderData.ts";

export const adminPanelDiscountCodeLoader: LoaderFunction = async ({ request }): Promise<PaginatedDiscountCodeLoaderData> => {
    const url = new URL(request.url);
    const page = parseInt(url.searchParams.get("page") || "1");
    const search = url.searchParams.get("search") || "";
    const limit = 10;

    try {
        const response = await apiEndpoints.getAdminDiscountCodes({
            pageNumber: page,
            pageSize: limit,
            search: search,
            desc: false,
            orderBy: "Code"
        });

        return {
            discountCodes: response.data.items || response.data,
            totalPages: response.data.totalPageCount,
            currentPage: page,
            totalItems: response.data.totalItemCount
        };
    } catch (error) {
        console.error("Discount codes loading error:", error);
        return {
            discountCodes: [],
            totalPages: 1,
            currentPage: 1,
            totalItems: 0
        };
    }
};